import type {
    RequiredCommonQueryParamsWithAuth,
    TrashByJobUuidAndFileUuidParams,
} from '~/@types/backend-types'
import { ThumbArea } from '~/@types/backend-types'
import { getCurrentLangDefinition, getDeviceProps } from '~/config/constants'
import { HostUrl } from '../toolbox'

export class ThumbService {
    private hostUrl: HostUrl

    constructor(hostname: string, authToken: string) {
        const commonQueryParams: RequiredCommonQueryParamsWithAuth = {
            auth: authToken,
            key: import.meta.env.VITE_API_KEY,
            client_v: import.meta.env.VITE_VERSION,
            device_id: getDeviceProps().device_id,
            app_lang: getCurrentLangDefinition().appLang,
        }
        this.hostUrl = new HostUrl(hostname, commonQueryParams)
    }

    // area[small, large] = [256, 1280]
    public getThumbUrl(
        jobID: JobID,
        fileID: FileID,
        area: ThumbArea = ThumbArea.SMALL,
    ): URLstring {
        return this.hostUrl.getPath(`/th/3/${fileID}`, {
            area,
            share: jobID,
        })
    }

    // area[small, large] = [256, 1280]
    public getTrashedThumbUrl(
        jobID: JobID,
        fileID: FileID,
        params: TrashByJobUuidAndFileUuidParams,
    ): URLstring {
        return this.hostUrl.getPath(`/th/3/trash/${jobID}/${fileID}`, params)
    }
}
